import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  buildDirectoryLabel,
  fileToPreviewViewModel,
  serverFileToPreviewViewModel,
} from '@components/Checkout/steps/PhoneNumberStep/utils/phoneNumberStepUtils';
import { FilePreviewCard } from '@components/Checkout/steps/PhoneNumberStep/FilePreviewCard';
import type { ViewOnlyProps } from '@components/Checkout/steps/PhoneNumberStep/PhoneNumberStep.types';

const CHOICE_LABELS: Record<string, string> = {
  NEWNUMBER: 'I Need a New Phone Number',
  PORTIN: 'I Want to Use My Existing Phone Number',
};

export const ViewOnly = ({ savedValues }: ViewOnlyProps) => {
  const isPortIn = savedValues?.choice === 'PORTIN';
  const choiceLabel = CHOICE_LABELS[savedValues?.choice ?? 'NEWNUMBER'];
  const providerLabel =
    savedValues?.portInProvider === 'Other' ? savedValues?.portInProviderOther : savedValues?.portInProvider;
  const phoneBillViews = [
    ...(savedValues?.existingPhoneBillFiles ?? []).map(serverFileToPreviewViewModel),
    ...(savedValues?.phoneBillFiles ?? []).map(fileToPreviewViewModel),
  ];
  const hasPhoneBillFiles = phoneBillViews.length > 0;

  return (
    <Box>
      <Stack gap="30px">
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Phone Number Option</Typography>
          <Typography className="CheckoutReadOnlyValue">{choiceLabel}</Typography>
        </Stack>

        {isPortIn && savedValues && (
          <>
            <Stack spacing={0.5} useFlexGap>
              <Typography className="CheckoutReadOnlyLabel">Existing Phone Number</Typography>
              <Typography className="CheckoutReadOnlyValue">{savedValues.portInNumber}</Typography>
            </Stack>
            <Stack spacing={0.5} useFlexGap>
              <Typography className="CheckoutReadOnlyLabel">Current Service Provider</Typography>
              <Typography className="CheckoutReadOnlyValue">{providerLabel}</Typography>
            </Stack>
            <Stack spacing={0.5} useFlexGap>
              <Typography className="CheckoutReadOnlyLabel">Account Number</Typography>
              <Typography className="CheckoutReadOnlyValue">{savedValues.accountNumber}</Typography>
            </Stack>
            <Stack spacing={0.5} useFlexGap>
              <Typography className="CheckoutReadOnlyLabel">Name on Bill</Typography>
              <Typography className="CheckoutReadOnlyValue">{savedValues.nameOnBill}</Typography>
            </Stack>
            {hasPhoneBillFiles && (
              <Stack spacing={0.5} useFlexGap>
                <Typography className="CheckoutReadOnlyLabel">Phone Bill</Typography>
                <Stack direction="row" gap="12px" flexWrap="wrap">
                  {phoneBillViews.map((view) => (
                    <FilePreviewCard key={view.key} view={view} />
                  ))}
                </Stack>
              </Stack>
            )}
          </>
        )}

        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">
            Directory Assistance (DA, 411) / Directory Listing (DL, phone book)
          </Typography>
          <Typography className="CheckoutReadOnlyValue">
            {buildDirectoryLabel(savedValues?.directoryListing ?? 'Listed')}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
